// api接口文件
var SERVER_DOMAIN = window.location.host;
var SERVE = SERVER_DOMAIN.split(':');
// var SERVER_HOST = window.location.protocol + '//' + SERVE[0]+':8000';
// var SERVER_HOST = 'http://121.40.207.191:8326';  //测试服
var SERVER_HOST = 'https://www.jzl.com'; //正式服
if (SERVER_HOST.indexOf('localhost') >= 0) {
    SERVER_HOST = '/api';
}
// SERVER_HOST = '/api';
const SERVER_HOST_MANAGER = SERVER_HOST + '/fbmain';
const SERVER_HOST_MANAGER1 = SERVER_HOST;
const API = {
    getlistApp: {
        url: SERVER_HOST_MANAGER + '/v1/same_owner_minipro',
        method: 'GET'
    },
    account: {
        login: { // 登录
            url: SERVER_HOST_MANAGER + '/account/v1/login',
            method: 'POST'
        },
        get_bd_vid: { // baidu
            url: SERVER_HOST_MANAGER + '/account/v1/get_bd_vid',
            method: 'GET'
        },
        api_aggregate: { // 万能接口
            url: SERVER_HOST_MANAGER + '/account/v1/api_aggregate',
            method: 'GET'
        },
        last_mpaccount: { // 最新收录公众号
            url: SERVER_HOST_MANAGER + '/account/v1/last_mpaccount',
            method: 'GET'
        },
        qq_binding: {
            url: SERVER_HOST_MANAGER + '/account/v1/qq_binding',
            method: 'POST'
        },
        qq_login: { // 登录
            url: SERVER_HOST_MANAGER + '/account/v1/qq_login',
            method: 'GET'
        },
        QQLogin: {
            url: SERVER_HOST_MANAGER + '/account/v1/get_qq_scan_code',
            method: 'GET'
        },
        userremaining: { // 用户余额
            url: SERVER_HOST_MANAGER + '/account/v1/user_remaining_amount',
            method: 'GET'
        },
        add_invoice_receiving_address: { // 发票增加收货地址
            url: SERVER_HOST_MANAGER + '/account/v1/add_invoice_receiving_address',
            method: 'POST'
        },
        del_invoice_receiving_address: { // 发票删除收货地址
            url: SERVER_HOST_MANAGER + '/account/v1/del_invoice_receiving_address',
            method: 'GET'
        },
        list_invoice_order: { // 开票记录
            url: SERVER_HOST_MANAGER + '/account/v1/list_invoice_order',
            method: 'GET'
        },
        update_invoice_receiving_address: { // 发票修改收货地址
            url: SERVER_HOST_MANAGER + '/account/v1/update_invoice_receiving_address',
            method: 'POST'
        },
        add_invoice_order: { // 提交发票订单
            url: SERVER_HOST_MANAGER + '/account/v1/add_invoice_order',
            method: 'POST'
        },
        invoice_receiving_address_details: { // 发票详情
            url: SERVER_HOST_MANAGER + '/account/v1/invoice_receiving_address_details',
            method: 'GET'
        },
        invoice_receiving_address_list: { // 发票列表
            url: SERVER_HOST_MANAGER + '/account/v1/invoice_receiving_address_list',
            method: 'GET'
        },
        details_invoice_order: { // 发票信息详情
            url: SERVER_HOST_MANAGER + '/account/v1/details_invoice_order',
            method: 'GET'
        },
        whether_admin: { // 查看是否是管理员
            url: SERVER_HOST_MANAGER + '/account/v1/whether_admin',
            method: 'GET'
        },
        update_invoice_status: { // 管理员更改发票状态
            url: SERVER_HOST_MANAGER + '/account/v1/update_invoice_status',
            method: 'POST'
        },
        admin_list_invoice_all: { // 管理员查看所有发票订单
            url: SERVER_HOST_MANAGER + '/account/v1/admin_list_invoice_all',
            method: 'GET'
        },
        list_user_order: { // 查询用户所有订单
            url: SERVER_HOST_MANAGER + '/account/v1/list_user_order',
            method: 'GET'
        },
        add_invoice: { // 添加发票信息
            url: SERVER_HOST_MANAGER + '/account/v1/add_invoice',
            method: 'POST'
        },
        del_invoice: { // 删除发票信息
            url: SERVER_HOST_MANAGER + '/account/v1/del_invoice',
            method: 'GET'
        },
        update_invoice: { // 修改发票信息
            url: SERVER_HOST_MANAGER + '/account/v1/update_invoice',
            method: 'POST'
        },
        list_user_invoice: { // 查询用户发票信息列表
            url: SERVER_HOST_MANAGER + '/account/v1/list_user_invoice',
            method: 'GET'
        },
        details_user_invoice: { // 查询用户发票信息详情
            url: SERVER_HOST_MANAGER + '/account/v1/details_user_invoice',
            method: 'GET'
        },
        qrcode: { // 获取微信二维码
            url: SERVER_HOST_MANAGER + '/account/v1/qrcode',
            method: 'GET'
        },
        register: { // 用户注册
            url: SERVER_HOST_MANAGER + '/account/v1/register',
            method: 'POST'
        },
        qq_register: { // qq用户注册
            url: SERVER_HOST_MANAGER + '/account/v1/qq_register',
            method: 'POST'
        },
        reset: { // 忘记密码
            url: SERVER_HOST_MANAGER + '/account/v1/reset',
            method: 'POST'
        },
        vip_info: { // 获取会员信息
            url: SERVER_HOST_MANAGER + '/account/v1/vip_info',
            method: 'POST'
        },
        user_vip_info: { // 获取会员信息
            url: SERVER_HOST_MANAGER + '/account/v1/vip_info',
            method: 'GET'
        },
        create_order: { // 生成订单
            url: SERVER_HOST_MANAGER + '/account/v1/create_order',
            method: 'POST'
        },
        pay_info: { // 获取支付信息
            url: SERVER_HOST_MANAGER + '/account/v1/pay_info',
            method: 'GET'
        },
        check_order_status: { // 获取订单支付状态
            url: SERVER_HOST_MANAGER + '/account/v1/check_order_status',
            method: 'GET'
        },
        sendCode: { // 发送验证码
            url: SERVER_HOST_MANAGER + '/account/v1/sendCode',
            method: 'POST'
        },
        register_collect: { // 用户信息
            url: SERVER_HOST_MANAGER + '/account/v1/register_collect ',
            method: 'POST'
        },
        consumption_record: { // 用户消费记录
            url: SERVER_HOST_MANAGER + '/account/v1/consumption_record',
            method: 'GET'
        },
        // 获取同主体公众号个数
        seeAccount: {
            url: SERVER_HOST_MANAGER + '/account/v1/same_owner_count',
            method: 'GET'
        },
    },
    pay: {
        alipay: { // 支付宝回调
            url: SERVER_HOST_MANAGER + '/pay/callback/alipay',
            method: 'POST'
        },
    },
    user: {
        login_out: { // 退出
            url: SERVER_HOST_MANAGER + '/user/v1/login_out',
            method: 'GET'
        },
        user_profile: { // 获取用户基本信息
            url: SERVER_HOST_MANAGER + '/user/v1/user_profile',
            method: 'GET'
        },
        invite_record: { // 获取推广记录
            url: SERVER_HOST_MANAGER + '/user/v1/invite_record',
            method: 'GET'
        },
        user_info: { // 获取用户信息
            url: SERVER_HOST_MANAGER + '/user/v1/user_info',
            method: 'GET'
        },
    },
    search: {
        region_list_all: {
            url: SERVER_HOST_MANAGER + '/account/v1/region_list_all',
            method: 'GET'
        },

        // 小程序搜索
        getSearch: {
            url: SERVER_HOST_MANAGER + '/search/v1/minipro_search',
            method: 'GET'
        },
        // 主体更新
        update_zhuti_info: {
            url: SERVER_HOST_MANAGER + '/search/v1/update_zhuti_info',
            method: 'POST'
        },
        // 点击刷新数据
        mp_update: {
            url: SERVER_HOST_MANAGER + '/search/v1/mp_update',
            method: 'POST'
        },
        // 详情关联文章
        getArticle: {
            url: SERVER_HOST_MANAGER + '/search/v1/minipro_article',
            method: 'GET'
        },
        // 详情关联公众号
        getMpaccount: {
            url: SERVER_HOST_MANAGER + '/search/v1/minipro_mpaccount',
            method: 'GET'
        },
        //小程序详情
        getDetail: {
            url: SERVER_HOST_MANAGER + '/search/v1/minipro_detail',
            method: 'GET'
        },
        key_search: { // 关键字检索接口
            url: SERVER_HOST_MANAGER + '/search/v1/key_search',
            method: 'POST'
        },
        search_by_name: { // 关键字检索接口（新）
            url: SERVER_HOST_MANAGER + '/search/v1/search_by_name',
            method: 'POST'
        },
        search_record: { // 搜索记录
            url: SERVER_HOST_MANAGER + '/search/v1/search_record',
            method: 'GET'
        },
        senior_search: { // 高级搜索记录
            url: SERVER_HOST_MANAGER + '/search/v1/senior_search/name',
            method: 'POST'
        },
        group_list: { // 小组列表
            url: SERVER_HOST_MANAGER + '/search/v1/group_list',
            method: 'GET'
        },
        group_list_ext: {
            url: SERVER_HOST_MANAGER + '/search/v1/group_list_ext',
            method: 'GET'
        },
        group_add: { // 小组添加
            url: SERVER_HOST_MANAGER + '/search/v1/group_add',
            method: 'POST'
        },
        group_delete: { // 删除小组
            url: SERVER_HOST_MANAGER + '/search/v1/group_delete',
            method: 'DELETE'
        },
        favorite_add: { // 公众号收藏
            url: SERVER_HOST_MANAGER + '/search/v1/favorite_add',
            method: 'POST'
        },
        article_search: { // 文章关键词搜索类
            url: SERVER_HOST_MANAGER + '/search/v1/article_search_/title',
            method: 'POST'
        },
        favorite_list: { // 收藏公众号列表
            url: SERVER_HOST_MANAGER + '/search/v1/favorite_list',
            method: 'POST'
        },
        favorite_delete: { // 取消收藏
            url: SERVER_HOST_MANAGER + '/search/v1/favorite_delete',
            method: 'POST'
        },
        collect_mp: { //收录
            url: SERVER_HOST_MANAGER + '/search/v1/collect_mp2',
            method: 'POST'
        },
        mp_detail: { // 公众号详情接口
            url: SERVER_HOST_MANAGER + '/search/v1/mp_detail',
            method: 'GET'
        },
        detail_pubList: { // 历史文章接口
            url: SERVER_HOST_MANAGER + '/search/v1/detail_pubList/time',
            method: 'GET'
        },
        detail_statistic: { // 历史文章接口
            url: SERVER_HOST_MANAGER + '/search/v1/detail_statistic',
            method: 'GET'
        },
        detail_owner: { // 主体详情
            url: SERVER_HOST_MANAGER + '/search/v1/detail_owner',
            method: 'GET'
        },
        delete_history: { // 删除搜索记录接口
            url: SERVER_HOST_MANAGER + '/search/v1/delete_history',
            method: 'GET'
        },
        mp_similar: { // 相似公众号
            url: SERVER_HOST_MANAGER + '/search/v1/mp_similar',
            method: 'GET'
        },
        mp_same_owner: { // 同主体公众号
            url: SERVER_HOST_MANAGER + '/search/v1/mp_same_owner',
            method: 'GET'
        },
        public_time: { // 公众号发文时段
            url: SERVER_HOST_MANAGER + '/search/v1/public_time',
            method: 'GET'
        },
        group_rename: { // 公众号更改分组
            url: SERVER_HOST_MANAGER + '/search/v1/group_rename',
            method: 'PUT'
        },
        favorite_article_option: { // 文章收藏列表
            url: SERVER_HOST_MANAGER + '/search/v1/favorite_article_option',
            method: 'GET'
        },
        favorite_article_option1: { // 文章收藏
            url: SERVER_HOST_MANAGER + '/search/v1/favorite_article_option',
            method: 'POST'
        },
        favorite_article_option2: { // 取消文章收藏
            url: SERVER_HOST_MANAGER + '/search/v1/favorite_article_option',
            method: 'DELETE'
        },
        collect_group_list: { // 文章与监控分组列表
            url: SERVER_HOST_MANAGER + '/search/v1/collect_group_list',
            method: 'GET'
        },
        collect_group_add: { // 文章与监控添加分组
            url: SERVER_HOST_MANAGER + '/search/v1/collect_group_add',
            method: 'POST'
        },
        collect_group_delete: { // 文章与监控删除分组
            url: SERVER_HOST_MANAGER + '/search/v1/collect_group_delete',
            method: 'DELETE'
        },
        collect_group_rename: { // 文章与监控更改分组
            url: SERVER_HOST_MANAGER + '/search/v1/collect_group_rename',
            method: 'PUT'
        },
        favorite_report_option: { // 监控收藏列表
            url: SERVER_HOST_MANAGER + '/search/v1/favorite_report_option',
            method: 'GET'
        },
      isExistReport: { // 判断报告是否存在
        url: SERVER_HOST_MANAGER + '/search/v1/isExistReport',
        method: 'GET'
      },
        favorite_report_option1: { // 添加监控收藏
            url: SERVER_HOST_MANAGER + '/search/v1/favorite_report_option',
            method: 'POST'
        },
        favorite_report_option2: { // 删除监控收藏
            url: SERVER_HOST_MANAGER + '/search/v1/favorite_report_option',
            method: 'DELETE'
        },
        userkeyword: { // 查看关键词列表
            url: SERVER_HOST_MANAGER + '/search/v1/userkeyword',
            method: 'GET'
        },
        userkeyword1: { // 添加关键词
            url: SERVER_HOST_MANAGER + '/search/v1/userkeyword',
            method: 'POST'
        },
        userkeyword2: { // 删除关键词
            url: SERVER_HOST_MANAGER + '/search/v1/userkeyword',
            method: 'DELETE'
        },
        userkeyword3: { // 置顶关键字
            url: SERVER_HOST_MANAGER + '/search/v1/userkeyword',
            method: 'PUT'
        },
        article_hot: { // 爆文
            url: SERVER_HOST_MANAGER + '/search/v1/article_hot',
            method: 'GET'
        },
        t_detail_statistic: { // 公众号详情折线图
            url: SERVER_HOST_MANAGER + '/search/v1/t_detail_statistic',
            method: 'GET'
        },
    },
    //假号检测
    monitor: {
        //对综合榜单进行筛选
        ManualSetMpAccountType: {
          url: SERVER_HOST_MANAGER + '/monitor/v1/ManualSetMpAccountType',
          method: 'POST',
        },
        api_user_detail: {
          url: SERVER_HOST_MANAGER + '/monitor/v3/api_user_detail',
          method: 'POST',
        },
        create_future_task: { // 创建预约监控
            url: SERVER_HOST_MANAGER + '/monitor/v1/create_future_task',
            method: 'POST'
        },
        create_future_monitor: { // 创建预约监控（新）
            url: SERVER_HOST_MANAGER + '/monitor/v1/create_future_monitor',
            method: 'POST'
        },
        history_task_list: { // 获取监控历史任务
            url: SERVER_HOST_MANAGER + '/monitor/v1/history_task_list',
            method: 'GET'
        },
        history_monitor_task_list: { // 获取监控历史任务(新)
            url: SERVER_HOST_MANAGER + '/monitor/v1/history_monitor_task_list',
            method: 'GET'
        },
        operate_task: { // 历史任务操作接口
            url: SERVER_HOST_MANAGER + '/monitor/v1/operate_task',
            method: 'POST'
        },
        getMidInfo: { // 获取监控信息
            url: SERVER_HOST_MANAGER + '/monitor/v1/getMidInfo',
            method: 'POST'
        },
        operate_monitor_task: { // 历史任务操作接口(新)
            url: SERVER_HOST_MANAGER + '/monitor/v1/operate_monitor_task',
            method: 'POST'
        },
        verifyLink: { // 通过文章地址搜索
            url: SERVER_HOST_MANAGER + '/monitor/v1/verifyLink',
            method: 'POST'
        },
        verifyMpAccountByLink: { // 通过文章地址搜索（新）
            url: SERVER_HOST_MANAGER + '/monitor/v1/verifyMpAccountByLink',
            method: 'POST'
        },
        monitor_list: { // 通过文章地址搜索
            url: SERVER_HOST_MANAGER + '/monitor/monitor_list',
            method: 'GET'
        },
        fake_list: { // 通过文章地址搜索
            url: SERVER_HOST_MANAGER + '/monitor/fake_list',
            method: 'GET'
        },
        read_praise_report: { // 获取监控阅读点赞报告
            url: SERVER_HOST_MANAGER + '/monitor/v1/read_praise_report',
            method: 'POST'
        },
        read_praise: { // 获取监控报告
            url: SERVER_HOST_MANAGER + '/monitor/v1/read_praise',
            method: 'POST'
        },
        read_zan_look_report: { // 获取监控报告详情（ 阅读，点赞，查看，报告 新 ）
            url: SERVER_HOST_MANAGER + '/monitor/v1/read_zan_look_report',
            method: 'POST'
        },
        spend_time: { // 获取使用次数
            url: SERVER_HOST_MANAGER + '/monitor/v1/spend_time',
            method: 'POST'
        },
        read_zan: { // 获取使用次数
            url: SERVER_HOST_MANAGER + '/monitor/v3/read_zan',
            method: 'GET'
        },
        tencent_claim: { // 公众号认领
            url: SERVER_HOST_MANAGER + '/monitor/v3/tencent_claim',
            method: 'POST'
        },
    },
    //历史采集
    history_crawl: {
        create_history_crawl: { // 新建历史采集任务
            url: SERVER_HOST_MANAGER + '/history_crawl/v1/create_history_crawl',
            method: 'POST'
        },
        history_crawl_list: { // 获取历史采集任务
            url: SERVER_HOST_MANAGER + '/history_crawl/v1/history_crawl_list',
            method: 'GET'
        },
        history_crawl_list1: { // 获取历史采集任务详情
            url: SERVER_HOST_MANAGER + '/history_crawl/v1/history_crawl_list',
            method: 'POST'
        },
        // 公告新闻更新
        new_data_storage: {
            url: SERVER_HOST_MANAGER + '/history_crawl/v1/new_data_storage',
            method: 'POST'
        },
        // 公告新闻标题列表
        new_data_title: {
            url: SERVER_HOST_MANAGER + '/history_crawl/v1/new_data_title',
            method: 'POST'
        },
        // 公告新闻内容
        new_data_notice_content: {
            url: SERVER_HOST_MANAGER + '/history_crawl/v1/new_data_notice_content',
            method: 'POST'
        },
        // 公告新闻内容
        official_account_contrast: {
            url: SERVER_HOST_MANAGER + '/history_crawl/v1/official_account_contrast',
            method: 'POST',
        },
        //品牌声量排行榜榜单
        brand_ranking: {
            url: SERVER_HOST_MANAGER + '/history_crawl/v1/brand_ranking',
            method: 'POST'
        },
        // 广告流量大盘
        brand_detail: {
            url: SERVER_HOST_MANAGER + '/history_crawl/v1/brand_detail',
            method: 'POST'
        },

        // 品牌柱状图
        brand_bar: {
            url: SERVER_HOST_MANAGER + '/history_crawl/v1/brand_bar',
            method: 'GET'
        },
    },
    //榜单
    rank: {
        common: { // 综合榜单
            url: SERVER_HOST_MANAGER + '/rank/v1/common',
            method: 'GET'
        },
        real: { // 真号榜单
            url: SERVER_HOST_MANAGER + '/rank/v1/real',
            method: 'GET'
        },
        media: { // 行业榜单
            url: SERVER_HOST_MANAGER + '/rank/v1/media',
            method: 'GET'
        },
        original: { // 原创榜单
            url: SERVER_HOST_MANAGER + '/rank/v1/original',
            method: 'GET'
        },
        fake: { // 假号榜单
            url: SERVER_HOST_MANAGER + '/rank/v1/fake',
            method: 'GET'
        },
        new_fake: { // 假号榜单
            url: SERVER_HOST_MANAGER + '/rank/v1/new_fake',
            method: 'GET'
        },
      new_fake_old: { // 老假号榜单
        url: SERVER_HOST_MANAGER + '/rank/v1/new_fake_old',
        method: 'GET'
      },
        area_rank: { // 地域榜单
            url: SERVER_HOST_MANAGER + '/rank/v1/area_rank',
            method: 'GET'
        },
        // 小程序榜单
        programTop: {
            url: SERVER_HOST_MANAGER + '/rank/v1/minipro_rank',
            method: 'GET'
        },
    },
    //定制
    need: {
        submit_demand: { // 定制需求提交
            url: SERVER_HOST_MANAGER + '/need/v1/submit_demand',
            method: 'POST'
        },
    },
    //地区
    area: {
        list: { // 市级
            url: SERVER_HOST_MANAGER + '/area/v1/list',
            method: 'GET'
        },
    },
    //用户邀请
    main: {
        invite_to_vip: {
            url: SERVER_HOST_MANAGER + '/main/v1/invite_to_vip',
            method: 'GET'
        },
        //领取奖励
        invite_to_vip1: {
            url: SERVER_HOST_MANAGER + '/main/v1/invite_to_vip',
            method: 'POST'
        },
        // 今日热文
        hotText: {
            url: SERVER_HOST_MANAGER + '/main/v1/today_hot',
            method: 'GET'
        },
    },
    //监控
    mpaccount: {
        monitor: { // 监控数量
            url: SERVER_HOST_MANAGER + '/mpaccount_monitor_num',
            method: 'GET'
        },
        monitor_list: { // 监控列表
            url: SERVER_HOST_MANAGER + '/mpaccount_monitor_list',
            method: 'GET'
        },
    },
    // api接口调用
    apis: {
        // 使用情况
        recharge_record: {
            url: SERVER_HOST_MANAGER + '/monitor/v1/api_usage',
            method: 'GET'
        },
        // 消费记录
        recharge_records: {
            url: SERVER_HOST_MANAGER + '/monitor/v1/api_records',
            method: 'GET'
        },
        // 充值续费 消费记录
        recharge_records1: {
            url: SERVER_HOST_MANAGER + '/monitor/v3/api_recharge_record',
            method: 'GET'
        },
        // 跳转到支付方式
        // API创建订单
        payment1: {
            url: SERVER_HOST_MANAGER + '/account/v1/api_create_order',
            method: 'POST'
        },
        // 获取支付url
        payment2: {
            url: SERVER_HOST_MANAGER + '/account/v1/api_pay_info',
            method: 'GET'
        },
        // 支付回调
        payment3: {
            url: SERVER_HOST_MANAGER + '/account/v1/api_pay_callback',
            method: 'GET'
        },
        // 确认订单状态
        payment4: {
            url: SERVER_HOST_MANAGER + '/account/v1/api_check_order_status',
            method: 'GET'
        },
        // 用户名 key 余额
        payment5: {
            url: SERVER_HOST_MANAGER + '/monitor/v3/api_user_detail',
            method: 'GET'
        },
    },
    // 原文应用
    text: {
        // 原文应用首页
        ranklisk1: {
            url: SERVER_HOST_MANAGER + '/original/v1/ranklisk',
            method: 'GET'
        },
        // 公众号关联小程序
        associatedapplet: {
            url: SERVER_HOST_MANAGER + '/original/v1/associated_applet',
            method: 'GET'
        },
        // 原文链接
        textlink: {
            url: SERVER_HOST_MANAGER + '/original/v1/original_text_link',
            method: 'GET'
        },
        // 原文应用 子应用
        ranklisk2: {
            url: SERVER_HOST_MANAGER + '/original/v1/onelevel',
            method: 'GET'
        },
        // 原文应用 热门文章
        ranklisk3: {
            url: SERVER_HOST_MANAGER + '/original/v1/hotarticle',
            method: 'GET'
        },
        // 原文应用 接入账号数据
        ranklisk4: {
            url: SERVER_HOST_MANAGER + '/original/v1/secondlevel',
            method: 'GET'
        },
        // 同主题公众号
        ranklisk5: {
            url: SERVER_HOST_MANAGER + '/account/v1/same_owner_count',
            method: 'GET'
        },
    },
    // 文章收藏
    article_collection: {
        favorite_article_option: {
            url: SERVER_HOST_MANAGER + '/search/v1/favorite_article_option',
            method: 'POST'
        },
        move_article_collect: {
            url: SERVER_HOST_MANAGER + '/search/v1/move_article_collect',
            method: 'POST'
        },
        get_favorite_article_option: {
            url: SERVER_HOST_MANAGER + '/search/v1/favorite_article_option',
            method: 'GET'
        },
        favorite_article_option_delete: {
            url: SERVER_HOST_MANAGER + '/search/v1/favorite_article_option',
            method: 'DELETE'
        },
        collect_group_list: {
            url: SERVER_HOST_MANAGER + '/search/v1/collect_group_list',
            method: 'GET'
        },
        collect_group_add: {
            url: SERVER_HOST_MANAGER + '/search/v1/collect_group_add',
            method: 'POST'
        },
        collect_group_rename: {
            url: SERVER_HOST_MANAGER + '/search/v1/collect_group_rename',
            method: 'PUT'
        },
        collect_group_delete: {
            url: SERVER_HOST_MANAGER + '/search/v1/collect_group_delete',
            method: 'DELETE'
        },
        collect_group_top: {
            url: SERVER_HOST_MANAGER + '/search/v1/collect_group_top',
            method: 'GET'
        },
        similar_article: {
            url: SERVER_HOST_MANAGER + '/follow/v1/similar_article',
            method: 'GET'
        }
    },
    // 我的关注
    myFollow: {
        follow_key_search: {
            url: SERVER_HOST_MANAGER + '/follow/v1/follow_key_search',
            method: 'GET'
        },
        getFollow: {
            url: SERVER_HOST_MANAGER + '/search/v1/group_list',
            method: 'GET'
        },
        group_list: {
            url: SERVER_HOST_MANAGER + '/search/v1/group_list',
            method: 'GET'
        },
        favorite_add: {
            url: SERVER_HOST_MANAGER + '/search/v1/favorite_add',
            method: 'POST'
        },
        group_add: {
            url: SERVER_HOST_MANAGER + '/search/v1/group_add',
            method: 'POST'
        },
        favorite_list: {
            url: SERVER_HOST_MANAGER + '/search/v1/favorite_list',
            method: 'POST'
        },
        follow_account_article: {
            url: SERVER_HOST_MANAGER + '/follow/v1/follow_account_article',
            method: 'GET'
        }
    },
    // 分组处理
    handle_group: {
        group_top: {
            url: SERVER_HOST_MANAGER + '/search/v1/group_top',
            method: 'GET'
        },
        group_delete: {
            url: SERVER_HOST_MANAGER + '/search/v1/group_delete',
            method: 'DELETE'
        },
        group_rename: {
            url: SERVER_HOST_MANAGER + '/search/v1/group_rename',
            method: 'PUT'
        }
    },
    // 关键词订阅
    subscribe: {
        subsrcibleSearch: {
            url: SERVER_HOST_MANAGER + '/search/v1/userkeyword',
            method: 'POST'
        },
        subsrcibleLook: {
            url: SERVER_HOST_MANAGER + '/search/v1/userkeyword',
            method: 'GET'
        },
        subsrciblePut: {
            url: SERVER_HOST_MANAGER + '/search/v1/userkeyword',
            method: 'PUT'
        },
        subsrcibleDelete: {
            url: SERVER_HOST_MANAGER + '/search/v1/userkeyword',
            method: 'DELETE'
        },
        user_keyword_search: {
            url: SERVER_HOST_MANAGER + '/search/v1/user_keyword_search',
            method: 'GET'
        },
        modify_userkeyword: {
            url: SERVER_HOST_MANAGER + '/search/v1/modify_userkeyword',
            method: 'POST'
        }
    }
};

module.exports = API;



// WEBPACK FOOTER //
// ./src/common/constants.js